import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { TaskEditing } from './task-editing';

export class Task extends Plugin {
  static get requires(): [unknown] {
    return [TaskEditing];
  }
}

export { InsertTaskCommand } from './insert-task-command';
export { ActiveTaskCommand } from './active-task-command';
export { RemoveTaskCommand } from './remove-task-command';
